import {
  SupportedLocale as SupportedLocaleType,
  useProjectBaseGetProjectByIdQuery,
  useProjectCandidateInviteManyMutation,
} from 'generated/graphql';
import { useAssigneesSelect } from 'hooks/useAssigneesSelect';
import { FC } from 'react';
import {
  TMultiselectOption,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import InviteNewCandidateForm from './InviteNewCandidateForm';

interface IInviteNewCandidate {
  projectId: number;
  projectSubId: string;
  stageSubId: string;
  closeModal: () => void;
}

const InviteNewCandidate: FC<IInviteNewCandidate> = ({
  projectId,
  projectSubId,
  stageSubId,
  closeModal,
}) => {
  const { handleMsgType } = useNotification();

  const { parsedAssigneesForSelect } = useAssigneesSelect(projectId);

  const [inviteMutation] = useProjectCandidateInviteManyMutation({
    onError: error => {
      handleMsgType({ type: TNotification.error, message: error?.message });
    },
    onCompleted: () => {
      handleMsgType({
        type: TNotification.success,
        title: 'Invitation sent!',
      });
      closeModal();
    },
  });

  const getProjectByIdResponse = useProjectBaseGetProjectByIdQuery({
    variables: { id: Number(projectId) },
    onError: error =>
      handleMsgType({
        type: TNotification.error,
        message: error?.message,
      }),
  });

  const projectLanguages = getProjectByIdResponse.data?.project?.locales;

  const handleInviteCandidate = (
    givenName: string,
    familyName: string,
    markedAsInternalCandidate: boolean,
    email: string,
    managerEmail: string,
    selectedAssignees: TMultiselectOption[],
    locale: SupportedLocaleType
  ) => {
    const assigneeIds = selectedAssignees
      .filter(assignee => assignee.value)
      .map(assigneeId => parseInt(assigneeId.value as string))
      .filter(id => !isNaN(id));

    inviteMutation({
      variables: {
        projectSubId,
        assessmentStageSubId: stageSubId,
        userDetails: {
          givenName,
          familyName,
          email,
        },
        settings: {
          supportedLocale: locale,
          areInternalCandidates: markedAsInternalCandidate,
          assignees: assigneeIds,
        },
      },
    });
  };
  return (
    <InviteNewCandidateForm
      availableAssignees={parsedAssigneesForSelect}
      projectLanguages={projectLanguages}
      projectId={projectId}
      onSubmit={handleInviteCandidate}
      onCancel={closeModal}
    />
  );
};

export default InviteNewCandidate;
